import { BULK_UNBILLABLE_PASSWORD } from './constants';

/** Helper text for the password field: empty input shows nothing. */
export const getBulkUnbillablePasswordInfoText = (password: string): string => {
  if (password.length === 0) return '';
  return password === BULK_UNBILLABLE_PASSWORD ? 'Password verified' : 'Password does not match';
};
